module.exports = __webpack_public_path__ + "img/thumb.899b6058.jpeg";